const COMODIDADES_BASE = [
  "Café em cápsulas",
  "Espuma de banho",
  "Sais de banho",
  "Roupões",
  "Carregamento p/ carro elétrico",
  "Roupa de cama",
  "Internet",
  "Decoração única",
  "Ar condicionado",
  "Hidromassagem",
  "Café da manhã grátis",
  "Lareira",
  "Frigobar",
  "Estacionamento acessível",
];

const COMODIDADES_SUPER = [
  "Café em cápsulas",
  "Piscina privativa",
  "Espuma de banho",
  "Sais de banho",
  "Roupões",
  "Carregamento p/ carro elétrico",
  "Roupa de cama",
  "Internet",
  "Decoração única",
  "Ar condicionado",
  "Hidromassagem",
  "Café da manhã grátis",
  "Lareira",
  "Frigobar",
  "Estacionamento acessível",
];

const fotos = (cat) => Array.from({ length: 8 }, (_, i) => `/fotos/${cat}/${i + 1}.webp`);

export const DECORACOES = [
  {
    id: "basica",
    nome: "Opção 1 — Básica",
    preco: 350,
    desc: "Pétalas de rosas sobre a cama, velas aromáticas decorativas, balões em formato de coração, frutas e chocolates finos. Ideal para surpresas simples e delicadas.",
  },
  {
    id: "premium",
    nome: "Opção 2 — Premium",
    preco: 480,
    desc: "Cama decorada com pétalas em formato de coração, balões no teto com fitas vermelhas, velas aromáticas + luminárias LED, bandeja com espumante, taças e morangos, música ambiente personalizada.",
  },
  {
    id: "luxo",
    nome: "Opção 3 — Luxo",
    preco: 650,
    desc: "Caminho de pétalas até o quarto, cama com decoração personalizada (iniciais do casal em pétalas), balões metalizados + cortina de coração, velas e iluminação romântica, espumante, frutas e fondue de chocolate, toalhas dobradas em formato de cisnes.",
  },
];

export const CATEGORIAS = [
  {
    id: "familia",
    numero: "01",
    titulo: "Chalés Super Luxo Família",
    diaria: 1350,
    descricao:
      "Seis chalés amplos pensados para receber a família inteira com conforto de resort e alma de refúgio: piscina privativa, hidromassagem, lareira e café da manhã servido no chalé.",
    mapa: "/fotos/familia/mapa.webp",
    fotos: fotos("familia"),
    comodidades: COMODIDADES_SUPER,
    chales: ["Napoli", "Portofino", "Amalfi", "Bellagio", "Capri", "Siena"],
  },
  {
    id: "superluxo",
    numero: "02",
    titulo: "Chalés Super Luxo",
    diaria: 1350,
    descricao:
      "Três chalés de puro requinte para casais: piscina privativa, hidromassagem, lareira, decoração única e o silêncio das montanhas como trilha sonora.",
    mapa: "/fotos/superluxo/mapa.webp",
    fotos: fotos("superluxo"),
    comodidades: COMODIDADES_SUPER,
    chales: ["Florença", "Roma", "Veneza"],
  },
  {
    id: "luxo",
    numero: "03",
    titulo: "Chalés Categoria Luxo",
    diaria: 1050,
    descricao:
      "O aconchego essencial do Laguna Alto Viçosa: hidromassagem, lareira, café da manhã incluso e cada detalhe pensado para dias inesquecíveis a dois.",
    mapa: "/fotos/luxo/mapa.webp",
    fotos: fotos("luxo"),
    comodidades: COMODIDADES_BASE,
    chales: ["Milão", "Sicília", "Toscana"],
  },
];

export const CONTATO = {
  whatsapp: "5528999873336",
  whatsappDisplay: "(28) 99987-3336",
  email: "admlagunaaltovicosa@gmail.com",
  endereco: "Estrada Artelatte — Alto Caxixe, Venda Nova do Imigrante — ES, CEP 29375-000",
  cnpj: "39.568.556/0001-14",
};
